export * from './barcode-carrier';
export * from './cdcc-number';
export * from './core';
export * from './credit-card-cvc';
export * from './credit-card-expire-date';
export * from './credit-card-number';
export * from './email';
export * from './micro-electric-bike-plate-number';
export * from './mobile';
export * from './plate-number';
export * from './taiwan-id-number';
export * from './taiwan-vehicle-registration-issue-date';
export * from './tax-id-number';
